import React, { useState, useCallback, useRef, useEffect } from 'react';
import { IScholars, PopupData } from 'types';
import { useHistory } from 'react-router-dom';
import Modal from 'components/common/modal/modal';
import Avatar from '@material-ui/core/Avatar';
import anetaPackBags from 'components/common/AnetaPackLibrary/anetaPackBags';
import edit from 'style/imgs/edit.svg';
import send from 'style/imgs/send.svg';
import close from 'style/imgs/icons/close-icon.svg';
import buttons from 'style/buttons.module.scss';
import AnetaPackUsage from './anetaPackUsage';
import styles from './index.module.scss';

interface Props {
  data: IScholars;
  deleteScholar: (id: number) => void;
  setActiveScholar?: (id: number) => void;
  activeScholarId: number;
  makeKidActive: (id: number) => void;
  isActiveSubscription: boolean;
  userType: string;
  popupData: PopupData;
}

const ScholarsListItem: React.FC<Props> = ({
  data,
  deleteScholar,
  activeScholarId,
  isActiveSubscription,
  makeKidActive,
  userType,
  popupData,
}) => {
  const { clickedChanged, popupIsOpened: isOpened } = popupData;
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalDelete, setModalDelete] = useState(false);
  const [anetapackIcon] = useState(
    anetaPackBags[Math.floor(Math.random() * 45)].img
  );

  const popupIsOpened = useRef<boolean>(isOpened);

  const [activityStatsBtnText, setActivityStatsBtnText] = useState(
    'Show Activity Stats'
  );
  const history = useHistory();

  const handleOpen = () => setModalOpen(!isModalOpen);

  const handleSendAnetapack = () => {
    makeKidActive(data.id);
    history.push('/сongratulations');
  };
  const handleEditAnetapack = () => {
    makeKidActive(data.id);
    history.push('/onboarding/timetable');
  };

  const onActivityStatsBtnClick = useCallback(
    (e: MouseEvent) => {
      popupIsOpened.current = true;

      const target = e.target as HTMLElement;
      clickedChanged(target);
    },

    [clickedChanged]
  );

  useEffect(() => {
    setActivityStatsBtnText(
      `${isOpened && popupIsOpened.current ? 'Hide' : 'Show'} Activity Stats`
    );

    popupIsOpened.current = false;
  }, [isOpened]);

  const isTeacher = userType === 'teacher';

  return (
    <div
      style={
        activeScholarId === data.id
          ? { border: ' 2px solid #10C9BE', boxShadow: '0px 15px 15px #d5d2f6' }
          : {}
      }
      role="button"
      tabIndex={0}
      onKeyDown={() => makeKidActive(data.id)}
      onClick={() => makeKidActive(data.id)}
      className={styles.scholarItem}
    >
      {isActiveSubscription && (
        <Modal
          isOpen={isModalDelete}
          trigger={
            <div className={styles.modalClose}>
              <button type="button">
                <img src={close} alt="delete" />
              </button>
            </div>
          }
          modalOpen={() => setModalDelete(!isModalDelete)}
          modalContent={
            <div className={styles.confirmDeleteModal}>
              <div className={`${styles.modalClose} ${styles.closeLeft}`}>
                <button
                  onClick={() => setModalDelete(!isModalDelete)}
                  type="button"
                >
                  <img src={close} alt="delete" />
                </button>
              </div>
              <h4>
                {userType === 'parent'
                  ? 'Are you sure you want to delete this scholar profile?'
                  : 'Are you sure you want to delete this class profile?'}
              </h4>
              <p>This action cannot be reversed.</p>
              <div className={styles.modalButtons}>
                <button
                  type="button"
                  className={buttons.buttonOutline}
                  onClick={() => setModalDelete(!isModalDelete)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={buttons.buttomPrimary}
                  onClick={() => deleteScholar(data.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          }
        />
      )}
      <div className={styles.scholarBag}>
        <img src={anetapackIcon} alt="anetapack" />
        {!isTeacher && (
          <>
            <span>Action ends:</span>
            <p>Jan 12, 2021</p>
          </>
        )}
      </div>
      <div className={styles.kidInfo}>
        <div className={styles.kidInfoHeading}>
          <Avatar
            style={{ height: '56px', width: '56px' }}
            src={data.avatar || ''}
            alt={data.name}
          />
          <h6 className={styles.kidsName} title={data.name}>
            {data.name}
          </h6>
          <div className={styles.activityStats}>
            <span
              className={`activityStatsBtn ${styles.activityStatsBtn}`}
              onClick={(e) =>
                onActivityStatsBtnClick((e as unknown) as MouseEvent)
              }
              onKeyPress={() => null}
              role="button"
              tabIndex={0}
            >
              {activityStatsBtnText}
            </span>
          </div>
        </div>
        {isTeacher && (
          <Modal
            trigger={
              <button type="button" className={styles.usageButton}>
                Usage Stats
              </button>
            }
            modalContent={
              <AnetaPackUsage anetapackId={data.id} anetapackName={data.name} />
            }
            isOpen={isModalOpen}
            modalOpen={handleOpen}
          />
        )}
        {!isTeacher && (
          <>
            <div className={styles.text}>
              Your Scholar is now: <span>in Music Room</span>
            </div>
            <div className={styles.text}>
              Remaining activities: 4 activities left
            </div>
          </>
        )}
        {isTeacher && <div className={styles.scolarListItemSpacer} />}
        <div className={styles.buttons}>
          <div
            role="button"
            tabIndex={0}
            onKeyDown={handleEditAnetapack}
            onClick={handleEditAnetapack}
            className={styles.button}
          >
            <div>
              <img src={edit} alt="edit" />
            </div>
            <span role="button">Edit Anetapack</span>
          </div>
          <div
            role="button"
            tabIndex={0}
            onKeyDown={handleSendAnetapack}
            onClick={handleSendAnetapack}
            className={styles.button}
          >
            <div>
              <img src={send} alt="send" />
            </div>
            <span>Send Anetapack</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScholarsListItem;
